// "CD Code" — header submenu (.has_child_menu) accordion toggle.
// Moved verbatim out of layout/theme.liquid so it loads with `defer` instead
// of running synchronously during body parse. `defer` runs after the document
// is parsed, so the header menu elements exist when this queries for them.
(function () {
  // CD Code
  document.querySelectorAll('.header-menu__inner .menu-list .child_menu .has_child_menu').forEach(function (menuItem) {
    menuItem.addEventListener('click', function (e) {
      e.preventDefault();
      // Close other open menus first
      document.querySelectorAll('.header-menu__inner .menu-list .child_menu .has_child_menu.active').forEach(function (openMenu) {
        if (openMenu !== e.currentTarget) {
          openMenu.classList.remove('active');
        }
      });
      this.classList.toggle('active');
    });
  });
})();
